import React from 'react';
import {
    Show,
    TextField,
    ReferenceField,
    SimpleShowLayout
} from 'react-admin';

import SgxDateField from '../components/sgxDateField';

const HistoricoValidacionesShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
        <TextField source="id" />
        <ReferenceField
            source="estado"
            reference="estado-validaciones"
            label="Estado"
        >
          <TextField source="descripcion" />
        </ReferenceField>
        <TextField source="numeroAfiliado"
                   label="resources.auditable-validaciones.fields.numeroAfiliado"/>
        <ReferenceField
            source="idPrestacion"
            reference="prestaciones"
            label="resources.auditable-validaciones.fields.prestacion"
        >
          <TextField source="descripcion"/>
        </ReferenceField>
        <SgxDateField source="fechaPrestacion" label="resources.auditable-validaciones.fields.fechaPrestacion"/>
        <SgxDateField source="createdOn" label="resources.historico-validaciones.fields.createdOn"/>
    </SimpleShowLayout>
  </Show>
);

export default HistoricoValidacionesShow;
